import { render, staticRenderFns } from "./LeadsNew.vue?vue&type=template&id=1edbaf7f&"
import script from "./LeadsNew.vue?vue&type=script&lang=js&"
export * from "./LeadsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports